export default "__VITE_ASSET__cead4a45__"